import { motion } from "framer-motion";
import { faqs } from "@/data";
import { fadeUp, viewport } from "@/lib/motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = () => {
  return (
    <section id="faq" className="py-24 md:py-32" data-testid="faq">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="font-display font-black tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight mb-12">
          Questions? <span className="text-[#ccff00]">Sorted.</span>
        </motion.h2>

        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display font-bold text-lg md:text-xl hover:text-[#ccff00] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
